import { show } from './methods/show';

const Popup = {
  show,
};

export default Popup;
